var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94B99D",
    fillRule: "evenodd",
    d: "m11.718 6.642-3.856 3.856c-.042.075-.08.153-.144.217a.95.95 0 0 1-.715.274.95.95 0 0 1-.716-.274c-.064-.064-.101-.142-.144-.217L4.287 8.642a.96.96 0 0 1 1.358-1.358l1.358 1.358 3.357-3.358a.96.96 0 0 1 1.358 1.358M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0"
  })));
});
const SvgUserBadgeApprovedIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserBadgeApprovedIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiM5NEI5OUQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjcxOCA2LjY0MmwtMy44NTYgMy44NTZjLS4wNDIuMDc1LS4wOC4xNTMtLjE0NC4yMTdhLjk0OS45NDkgMCAwIDEtLjcxNS4yNzQuOTUuOTUgMCAwIDEtLjcxNi0uMjc0Yy0uMDY0LS4wNjQtLjEwMS0uMTQyLS4xNDQtLjIxN0w0LjI4NyA4LjY0MmEuOTYuOTYgMCAwIDEgMS4zNTgtMS4zNThsMS4zNTggMS4zNTggMy4zNTctMy4zNThhLjk2Ljk2IDAgMCAxIDEuMzU4IDEuMzU4TTggMGE4IDggMCAxIDAgMCAxNkE4IDggMCAwIDAgOCAwIi8+Cjwvc3ZnPgo=";